import React from "react";
import MainSlider from "../components/MainSlider/index";
import ProductTabs from "../components/productSliderTabs";
import ClientCarousel from "../components/clientCarousel/index";
import NewProductc from "../components/newrelease/index";
import useSeo from "../services/useSeo";

function Home(props) {
  // Force the homepage canonical to "/" so /index.html and any junk path that
  // used to render Home never compete with it.
  useSeo({
    title: "琴語鋼琴網 - 全台最大鋼琴譜下載網站",
    description:
      "琴語鋼琴網提供各式高品質鋼琴譜下載，包含流行音樂、古典音樂、動漫音樂等各類型的鋼琴譜和簡譜，亦提供客製化的鋼琴譜製作服務。",
    canonicalPath: "/",
  });

  return (
      <div>
        <MainSlider />
        {/* <Types /> */}
        <ProductTabs />
        {/* <Brandslogo /> */}
        {/* <ProductCard slides={allProducts} /> */}
        <NewProductc limit={8}></NewProductc>
        <ClientCarousel />
      </div>
  );

}

export default Home;
